import React, { useState } from 'react';
import { motion } from 'framer-motion';
import CityInput from '../components/CityInput';
import WeatherDisplay from '../components/WeatherDisplay';
import TerminalHeader from '../components/TerminalHeader';
import { fetchWeather } from '../utils/weatherApi';
import './App.css';

function App() {
  const [weather, setWeather] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [history, setHistory] = useState([]);

  // Функция для поиска погоды
  const searchWeather = async (city) => {
    if (!city.trim()) return;
    
    setLoading(true);
    setError('');
    
    try {
      const data = await fetchWeather(city);
      setWeather(data);
      // Добавляем город в историю
      setHistory(prev => [city, ...prev.filter(c => c !== city)].slice(0, 5));
    } catch (err) {
      setError('ГОРОД НЕ НАЙДЕН...');
      setWeather(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="terminal-container">
      {/* Терминальный заголовок */}
      <TerminalHeader />
      
      {/* Основное окно */}
      <motion.div 
        className="terminal-window"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        {/* Ввод города */}
        <CityInput onSearch={searchWeather} loading={loading} />
        
        {/* История запросов */}
        {history.length > 0 && (
          <div className="history-section">
            <div className="history-title">
              <span className="prompt">$</span> ПОСЛЕДНИЕ ЗАПРОСЫ:
            </div>
            <div className="history-list">
              {history.map((city, index) => (
                <button
                  key={index}
                  onClick={() => searchWeather(city)}
                  className="history-item"
                >
                  &gt; {city}
                </button>
              ))}
            </div>
          </div>
        )}
        
        {/* Ошибка */}
        {error && (
          <motion.div 
            className="error-message"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <span className="error-symbol">!</span> {error}
          </motion.div>
        )}
        
        {/* Загрузка */}
        {loading && (
          <div className="loading">
            <span className="blink">ЗАГРУЗКА ДАННЫХ</span>
            <span className="dots">...</span>
          </div>
        )}
        
        {/* Погода */}
        {weather && !loading && (
          <WeatherDisplay weather={weather} />
        )}
        
        {/* Курсор в конце */}
        <div className="cursor-line">
          <span className="prompt">$</span> <span className="blink">_</span>
        </div>
      </motion.div>
      
      {/* Подвал с системной информацией */}
      <div className="footer">
        <span>ПОДКЛЮЧЕНИЕ: {weather ? 'АКТИВНО' : 'ОЖИДАНИЕ'}</span>
        <span>ВЕРСИЯ 2.0.23</span>
        <span>||</span>
        <span>ВРЕМЯ: {new Date().toLocaleTimeString()}</span>
      </div>
    </div>
  );
}

export default App;